export const environment = {
  production: true,
  apiBaseUrl: 'https://namm.sulsira.com',
};
